import { render, staticRenderFns } from "./panelTitular.vue?vue&type=template&id=5bc00ed6"
import script from "./panelTitular.vue?vue&type=script&lang=js"
export * from "./panelTitular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports